import type { SVGProps } from 'react';

export function RemoveIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.75 3.5H12.25"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0836 3.5V11.6667C11.0836 12.25 10.5003 12.8333 9.91699 12.8333H4.08365C3.50032 12.8333 2.91699 12.25 2.91699 11.6667V3.5"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 3.49996V2.33329C4.66699 1.74996 5.25032 1.16663 5.83365 1.16663H8.16699C8.75032 1.16663 9.33365 1.74996 9.33365 2.33329V3.49996"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83301 6.41663V9.91663"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16699 6.41663V9.91663"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
